import { getSetGlobalLocale } from './locales.service';
import { toInt } from '../utils/type-checks';
getSetGlobalLocale('en', {
    dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
    ordinal: function (num) {
        var b = num % 10;
        var output = (toInt(num % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                    (b === 3) ? 'rd' : 'th';
        return num + output;
    }
});
//# sourceMappingURL=en.js.map


//////////////////
// WEBPACK FOOTER
// C:/Agent0/_work/434/s/~/ngx-bootstrap/bs-moment/locale/en.js
// module id = ../../../../ngx-bootstrap/bs-moment/locale/en.js
// module chunks = 3